import css from 'styled-jsx/css';

export default css`.MobileCarousel, .content {
  /* autoprefixer: ignore next */
  -webkit-overflow-scrolling: touch;
  /* autoprefixer: ignore next */
  overflow-scrolling: touch; }

.content {
  /* autoprefixer: ignore next */ }
  .content::-webkit-scrollbar {
    display: none; }

.MobileCarousel {
  position: relative;
  display: flex;
  width: 100%;
  max-height: 540px;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  overflow: hidden;
  box-sizing: border-box;
  background-color: #F2F2FF; }
  @media (min-width: 768px) {
    .MobileCarousel {
      display: none; } }
  .MobileCarousel * {
    color: #333333;
    box-sizing: border-box; }
  .MobileCarousel :global(~ .masonry-layout) {
    margin-top: 0; }

.title {
  width: 100%;
  max-width: 1610px;
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: center;
  padding: 12px 6px 12px 12px;
  margin: auto;
  z-index: 0;
  font-weight: 500; }
  .title > span {
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    line-height: 1.5rem; }
  @media screen and (min-width: 500px) {
    .title * {
      color: #444; } }

.title > a,
.link {
  cursor: pointer;
  display: inline-flex;
  flex-flow: row nowrap;
  justify-content: flex-end;
  align-items: center;
  line-height: 1.5rem;
  overflow: hidden;
  color: #999999; }
  .title > a span,
  .link span {
    margin-right: 4px;
    color: #7D7AF4;
    font-size: 14px; }

.content {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  overflow: auto; }

.item {
  cursor: pointer;
  flex: none;
  width: 230px;
  border: 0 solid #eee;
  margin-bottom: 24px; }
  @media screen and (min-width: 500px) {
    .item {
      padding: 0 8px; } }
  .item article,
  .item :global(article) {
    width: 100%;
    border: 0 solid #eee;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
    background-color: #fff;
    margin: 0;
    transition: transform 0.2s linear;
    transform: scale(0.8); }
    @media screen and (min-width: 500px) {
      .item article,
      .item :global(article) {
        transform: scale(1); } }
  .item.active article,
  .item.active :global(article) {
    transition: transform 0.2s linear;
    transform: scale(1); }
  .item:first-of-type {
    padding-left: 30px; }
    @media screen and (min-width: 500px) {
      .item:first-of-type {
        padding-left: 8px; } }
  .item:last-of-type {
    padding-right: 35px; }
    @media screen and (min-width: 500px) {
      .item:last-of-type {
        padding-right: 8px; } }
`